import { render, staticRenderFns } from "./couponMobile.vue?vue&type=template&id=17a4a07e&scoped=true"
import script from "./couponMobile.vue?vue&type=script&lang=js"
export * from "./couponMobile.vue?vue&type=script&lang=js"
import style0 from "./couponMobile.vue?vue&type=style&index=0&id=17a4a07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a4a07e",
  null
  
)

export default component.exports